// extracted by mini-css-extract-plugin
module.exports = {"addButton":"ChannelAddress_addButton__m185X","confirmTextName":"ChannelAddress_confirmTextName__32Tz9","addressErrorCloseBtn":"ChannelAddress_addressErrorCloseBtn__3H3Qq"};